import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, pxToRem, size } from '@twistopayments/design-system/styles'

export const title = css`
  font-size: ${pxToRem(32)};
  line-height: 1.2;
  margin-top: ${size[24]};

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
  }
`
export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`
